/**
 * TK-45 §2 (lee 25/10) — ĐỐI TƯỢNG ĐANG THAO TÁC: tuyến › tủ › đèn, hiện ở thanh đáy để cuộn xuống vẫn biết mình đang làm trên
 *   đối tượng nào. MỘT kho cấp module (không Provider): trang nào có chọn thì gọi `useDatDoiTuong(...)`; rời trang ⇒ tự xoá.
 */
import { useEffect, useSyncExternalStore } from 'react';

export interface DoiTuong { tuyen?: string | null; tu?: string | null; den?: string | null }

let hienTai: DoiTuong | null = null;
const nghe = new Set<() => void>();
const dat = (v: DoiTuong | null) => { hienTai = v; for (const f of nghe) f(); };

/** Các cấp đang có, thứ tự tuyến › tủ › đèn — trống / null bỏ. Thuần. */
export function capDoiTuong(dt: DoiTuong | null): string[] {
  if (!dt) return [];
  return [dt.tuyen, dt.tu, dt.den].filter((x): x is string => typeof x === 'string' && x.trim() !== '');
}

/** Trang đặt đối tượng đang chọn (đổi thì cập nhật; rời trang thì xoá). */
export function useDatDoiTuong(dt: DoiTuong | null) {
  const tuyen = dt?.tuyen ?? null, tu = dt?.tu ?? null, den = dt?.den ?? null;
  useEffect(() => { const v = { tuyen, tu, den }; dat(capDoiTuong(v).length ? v : null); }, [tuyen, tu, den]);
  useEffect(() => () => dat(null), []);
}

/**
 * TK-46 §3 — thanh đáy THIẾU CHỖ thì nhường theo thứ tự (bề rộng thanh = bề rộng cửa sổ, thanh `fixed` trọn ngang):
 *   1. luôn giữ trọn cấp CUỐI (tủ / đèn);  2. tuyến rút gọn (trần px) → chỉ còn biểu tượng tuyến (tên trong `title`);
 *   3. ẩn "x/y tủ trực tuyến" → ẩn chữ "Máy chủ kết nối" (chỉ còn chấm). "Dữ liệu thời gian thực" nhường trước hết.
 */
export interface CachHienDay { cheDo: boolean; tuyen: 'day-du' | 'rut-gon' | 'bieu-tuong'; tranTuyen: number | null; soTu: boolean; chuMayChu: boolean }
export function cachHienThanhDay(rong: number): CachHienDay {
  if (rong >= 1024) return { cheDo: true, tuyen: 'day-du', tranTuyen: null, soTu: true, chuMayChu: true };
  if (rong >= 760) return { cheDo: false, tuyen: 'rut-gon', tranTuyen: 200, soTu: true, chuMayChu: true };
  if (rong >= 560) return { cheDo: false, tuyen: 'rut-gon', tranTuyen: 110, soTu: true, chuMayChu: true };
  if (rong >= 480) return { cheDo: false, tuyen: 'bieu-tuong', tranTuyen: 0, soTu: true, chuMayChu: true };
  if (rong >= 420) return { cheDo: false, tuyen: 'bieu-tuong', tranTuyen: 0, soTu: false, chuMayChu: true };
  return { cheDo: false, tuyen: 'bieu-tuong', tranTuyen: 0, soTu: false, chuMayChu: false };
}

/** Bề rộng cửa sổ (đổi theo resize / xoay máy). */
export function useBeRongCuaSo(): number {
  return useSyncExternalStore(
    (f) => { window.addEventListener('resize', f); return () => window.removeEventListener('resize', f); },
    () => window.innerWidth,
  );
}

/** Thanh đáy đọc. */
export function useDoiTuongDangChon(): DoiTuong | null {
  return useSyncExternalStore((f) => { nghe.add(f); return () => { nghe.delete(f); }; }, () => hienTai);
}
